/* eslint-disable @typescript-eslint/no-explicit-any */

export class StorageService {
  localStorageSupported: boolean;

  constructor() {
    try {
      this.localStorageSupported =
        typeof window['localStorage'] != 'undefined' && window['localStorage'] != null;
    } catch (e) {
      this.localStorageSupported = false;
    }
  }

  // add value to storage
  set(key: string, item: any) {
    if (this.localStorageSupported) {
      const dataJson = JSON.stringify(item);
      localStorage.setItem(key, dataJson);
    }
  }

  // get one item by key from storage
  get<T>(key: string, defaultValue: T | null = null): T | string | null {
    if (this.localStorageSupported) {
      const itemStr = localStorage.getItem(key);
      try {
        return itemStr ? JSON.parse(itemStr) : defaultValue;
      } catch (err) {
        return itemStr;
      }
    } else {
      return defaultValue;
    }
  }

  // remove value from storage
  remove(key: string): void {
    if (this.localStorageSupported) {
      localStorage.removeItem(key);
    }
  }

  // clear storage (remove all items from it)
  clear() {
    if (this.localStorageSupported) {
      localStorage.clear();
    }
  }

  //add value to session storage
  setSession(key: string, item: any) {
    if (this.localStorageSupported) {
      const dataJson = JSON.stringify(item);
      sessionStorage.setItem(key, dataJson);
    }
  }

  getSession<T>(key: string, defaultValue: T | null = null): T | string | null {
    if (this.localStorageSupported) {
      try {
        const itemStr = sessionStorage.getItem(key);
        return itemStr ? JSON.parse(itemStr) : defaultValue;
      } catch (err) {
        return sessionStorage.getItem(key);
      }
    } else {
      return defaultValue;
    }
  }
}

export default new StorageService();
